import { render, staticRenderFns } from "./VesselHistory.vue?vue&type=template&id=0b45190c"
import script from "./VesselHistory.vue?vue&type=script&lang=js"
export * from "./VesselHistory.vue?vue&type=script&lang=js"
import style0 from "./VesselHistory.vue?vue&type=style&index=0&id=0b45190c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports